import { User } from "../user/user";

export class EmployeeProfile extends User {
  position: string | null | undefined;
}
